/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEventNote = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9.001 1v2H15V1h2.001v2H23v20H1V3h6.001V1zM21 5h-3.999v1.999H15V5H9.001v1.999h-2V5h-4L3 21h18zm-7 12v2H6v-2zm4-4v2H6v-2zm0-4v2H6V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEventNote as EventNote };
